import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { ICurrentUser } from "./types"

const initialState: ICurrentUser = {
  id: "",
  name: "",
  username: "",
  role: 0,
  telegram: false,
  priceDiffPercent: 0,
  isTwoCopiesPrint: 0,
}

export const currentUserSlice = createSlice({
  name: "currentUser",
  initialState: initialState,
  reducers: {
    currentUserSetData: (state, action: PayloadAction<ICurrentUser>) => {
      state.id = action.payload.id
      state.name = action.payload.name
      state.username = action.payload.username
      state.role = action.payload.role
      state.telegram = action.payload.telegram
      state.priceDiffPercent = action.payload.priceDiffPercent
      state.isTwoCopiesPrint = action.payload.isTwoCopiesPrint
    },
    currentUserClearData: (state) => {
      state.id = initialState.id
      state.name = initialState.name
      state.username = initialState.username
      state.role = initialState.role
      state.telegram =initialState.telegram
    },
    currentUserSetPrintData: (state, action) => {
      state.isTwoCopiesPrint = action.payload;
    }
  }
})

export const currentUserSliceActions = currentUserSlice.actions
export const currentUserSliceReducer = currentUserSlice.reducer
